import { sanitizeHtml } from "common/utils/sanitizeHtml";
import { PlaceOfBirth } from "entities/User";
import { useState } from "react";
import { Form, Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Button } from "shared/ui";
import "./TravelPolicyModal.styles.css";

function TravelPolicyModal({ show, userCountryCode, message, handleSubmit }) {
  const { t } = useTranslation("Shared");
  const [isLoading, setIsLoading] = useState(false);
  const [formValues, setFormValues] = useState({
    birth_of_place: "",
    gdpr: false,
    iss_travel_terms: false,
  });

  const handleFormValuesChange = (e, value) =>
    setFormValues((prev) => ({
      ...prev,
      [e.target.name]: value,
    }));

  const [validated, setValidated] = useState(false);

  const onSubmit = async (event) => {
    const form = event.currentTarget;
    event.preventDefault();
    event.stopPropagation();
    if (form.checkValidity()) {
      setIsLoading(true);
      await handleSubmit(formValues);
      setIsLoading(false);
    }
    setValidated(true);
  };

  return (
    <Modal show={show}>
      <Form noValidate validated={validated} onSubmit={onSubmit}>
        <Modal.Header>
          <Modal.Title>{t("privacy_clause.title")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group className="mb-3">
            <Form.Check
              id="dsv-iss-travel-policy"
              type="switch"
              name="iss_travel_terms"
              checked={formValues.iss_travel_terms}
              onChange={(e) => handleFormValuesChange(e, e.target.checked)}
              required
              label={
                <small
                  className="text-primary travel-policy-message"
                  dangerouslySetInnerHTML={{
                    __html: sanitizeHtml(message),
                  }}
                ></small>
              }
              feedback={t("privacy_clause.required")}
              feedbackType="invalid"
            />
          </Form.Group>
          {userCountryCode === "PL" && (
            <>
              <hr className="my-4 text-muted" />
              <PlaceOfBirth
                value={formValues.birth_of_place}
                onChange={(e) => handleFormValuesChange(e, e.target.value)}
              />
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button type="submit" isLoading={isLoading} disabled={isLoading}>
            {t("buttons.submit")}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
}

export default TravelPolicyModal;
